import Component from './Component'

export default class SelectPicker extends Component {

	static _type = 'SelectPicker'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('select')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Extend select
		$(this.input_el).selectpicker({
			actionsBox: true,
			container: 'body',
			styleBase: 'form-control',
			style: '',
			title: 'Nincs kiválasztva'
		})

		// Create bound event handlers and register them
		this.inputListener = SelectPicker._inputListener.bind(this)
		this.updateListener = SelectPicker._updateListener.bind(this)
		$(this.input_el).on('change', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event
	}

	static _inputListener () {
		// Send data to the record
		this.form.data[this.params.name] = $(this.input_el).val()
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if ($(this.input_el).val() != value) {
			$(this.input_el).val(value)
		}

		// Refresh extension
		$(this.input_el).selectpicker('refresh')

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {

		console.log('select rendering validation', errors)

		if (errors == null) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('change', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		// Destroy extension
		$(this.input_el).selectpicker('destroy')

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
